import React from "react";
import "./index.scss";
import {Link} from "react-router-dom";
import {PATHS} from "@config/constants";

const HomeHeader = ({ tabActive }) => {
  return (
      <div className="header">
          <ul className="menu">
              <li className={`${(tabActive === 1) ? 'active' : ''}`}><Link to={PATHS.HOME_PAGE}>Cómo participar</Link></li>
              <li className={`${(tabActive === 2) ? 'active' : ''}`}><Link to={PATHS.RULES_PAGE}>Reglas</Link></li>
              <li className={`${(tabActive === 3) ? 'active' : ''} mr-0`}><Link to={PATHS.DELIVERY_PAGE}>¿Cómo recibo mi premio si gané? </Link></li>
          </ul>
      </div>
  );
};

export default HomeHeader;

